

//
export const useFormGeneratorField = (props) => {
  let infotip = null;
  let warningtip = null;

  let params = {};
  if (props.params) {
    params = props.params;
  }
  let name = 'unnamed';
  if (typeof params.name === 'string' && params.name !== '') {
    name = params.name;
  }
  let formState = {};
  if (props.formState) {
    formState = props.formState;
  }

  let value;
  value = formState[name];
  let valueToDisplay = value;

  if (typeof value === 'undefined') {
    warningtip = 'undefined';
    valueToDisplay = '';
  } else if (value === null) {
    warningtip = 'null';
    valueToDisplay = '';
  } else if (typeof value === 'number' && isNaN(value)) {
    warningtip = 'NaN';
    valueToDisplay = '';
  }

  return {
    infotip,
    warningtip,
    valueToDisplay,
  };
};